import { useMutation, useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

export function useGetSafraEOcupacaoPeriodo(filters: any) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_DROPDOWN_PERIODO_FILTRO, filters],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_DROPDOWN_PERIODO_FILTRO(filters?.safraId, filters?.ocupacaoId), {});
      
      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!filters.ocupacaoId,
    }
  );
}

export function useGetSafraEUnidadePeriodo() {
  return useMutation(async ({ filters }: { filters: any }) => {
    const response = await http.delete(
      URL.PLANO_OPERACIONAL.OBTER_DROPDOWN_PERIODO(filters.safraId, filters.ocupacaoId),
    );
    return response;
  });
}